import React, {FC} from 'react';
import {useTheme} from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {hideBannerAction} from '../../../../../libs/shared/core/src/store/banners/commonBannerActions';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {AiInaccurateTagBannerState} from '../../../../store/panels/app/banners/bannersState';

/*
 * Props.
 */

interface AiReportedInaccurateTagBannerProps {
  bannerState: AiInaccurateTagBannerState;
}

/*
 * Component.
 */

export const AiReportedInaccurateTagBanner: FC<AiReportedInaccurateTagBannerProps> = (props) => {
  const {bannerState} = props;
  const dispatch = useAppDispatch();
  const hideBanner = () => {
    dispatch(hideBannerAction(bannerState.uid));
  };
  const theme = useTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      priority={BannerPrioritiesEnum.INFORMATION}
      color={theme.palette.grey.shade40}
    >
      <BannerCloseAction onClick={hideBanner} />
      <BannerIcon iconName="untag" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="ai-reported-inaccurate-tag-banner-title">Inaccurate tag removed</Trans>
        </BannerContentTitle>
        <Trans id="ai-reported-inaccurate-tag-banner-body">We&apos;ll use this to improve auto tagging</Trans>
      </BannerContent>
    </Banner>
  );
};
